<template>
  <div class="help-center-button">
    <v-menu top
            offset-y
            :nudge-top="10"
            :close-on-content-click="false"
            :close-on-click="false"
            v-model="showPopupMenu"
            class="elevation-0"
            content-class="fin-help-center-tooltip"
            eager
            :max-width="350">
      <template #activator="{ on }">
        <v-btn @click="openHelpCenter"
               :color="$finColors.secondaryBlue"
               fab
               class="fin-icon-academy">
          <v-icon color="white" size="32px">icon-academy</v-icon>
        </v-btn>
        <!-- Empty div to bind activator to nothing-->
        <div v-on="on"/>
      </template>

      <div class="fin-tooltip-help-center">
        <v-col class="px-4">
          <v-btn @click="closePopup"
                 class="fin-icon-close"
                 icon>
            <v-icon size="16px">icon-close</v-icon>
          </v-btn>

          <div class="tooltip-title py-2">Hilfezentrum</div>
          <div class="tooltip-text">
            Hier findest du weitere Hilfestellungen in Form von geführten Touren, Videos oder Erklärungen.
          </div>
          <div class="d-flex justify-end mt-2">
            <v-btn @click="openHelpCenter">
              Öffnen
            </v-btn>
          </div>
        </v-col>
      </div>
    </v-menu>
  </div>
</template>

<script>
import {EventBus} from '@/plugins/fincraft'
import AmplitudePush from "@/mixins/AmplitudePush"
import {mapState} from "vuex"

export default {
  name: 'FinHelpCenterButton',
  mixins: [AmplitudePush],
  props: {
    /**
     * Optional: Route name
     */
    contextID: {
      type: String,
    },
    /**
     * Sets if the popup should be shown
     */
    showPopup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      autoRunTour: null,
      showPopupMenu: this.showPopup,
    }
  },
  computed: {
    ...mapState({
      profile: state => state.auth.profile
    }),
    localStorageId() {
      return `helpCenter_popup_${this.profile.id}`
    }
  },
  methods: {
    openHelpCenter() {
      this.pushToAmplitude({
        'event': 'fincraft_helpcenter_button',
        'step': 'helpcenter_button',
        'placement': 'page_button',
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })
      this.closePopup()
      EventBus.$emit('showHelpCenter', null, false)
    },
    closePopup() {
      localStorage.setItem(this.localStorageId, 'true')
      this.showPopupMenu = false
      this.$emit('closePopup')
    }
  },
}
</script>

<style lang="scss" scoped>

.help-center-button {
  position: fixed;
  bottom: 0;
  right: 0;
  margin: 10px 24px 10px 10px;
  background-color: transparent;
  border-radius: 50% !important;
  box-shadow: 4px 4px 0 0 rgba($fin-color-primary-dark, 0.1);
  z-index: 100;
}

.to-help-center-text {
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 22px;
  letter-spacing: normal;
  cursor: pointer;
}


.v-menu__content {
  box-shadow: none !important;
  border: 0 !important;
  margin-right: 24px;
  border-radius: 0 !important;
}

</style>
